import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import React from 'react';
import clockAnimation2 from '../../static/lottie/clock-1.json';
import clockAnimation from '../../static/lottie/clock.json';
import { ClockStyles } from './Clock.style';

const Clock = ({ variant = 1 }) => {
  const animationData = variant === 1 ? clockAnimation : clockAnimation2;

  return (
    <div className="clock-container">
      <Lottie animationData={animationData} loop autoPlay />
      <style jsx>{ClockStyles}</style>
    </div>
  );
};

Clock.propTypes = {
  variant: PropTypes.number.isRequired,
};

export default Clock;
